import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import {
    lookupUserForLinking as lookupUserForLinkingAction,
    clearAuthNotification as clearAuthNotificationAction,
    linkAccountOnNewUser,
    existingAccountCheck,
    setEmail,
} from '../../actions/auth';

import {
    cancelToS as cancelToSAction,
    acceptSocialToS as acceptSocialToSAction,
    showToS as showToSAction,
} from '../../actions/tos';

import {
    trackSIWA_AccountsLinkOptionWithHiddenEmail,
    trackSIWA_AccountLinkAttemptWithHiddenEmail,
} from '../../actions/gaTracking';

import SocialLookupPage from './SocialLookupPage';

const _mapStateToProps = ({ authentication, social }) => ({
    socialData: social.socialData,
    userHasAccount: authentication.userHasAccount,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
});

const _mapDispatchToProps = {
    onLookupUser: lookupUserForLinkingAction,
    clearAuthNotification: clearAuthNotificationAction,
    linkAccountOnNewUser,
    onExistingAccountCheck: existingAccountCheck,
    setEmail,
    trackOnLoadPage: trackSIWA_AccountsLinkOptionWithHiddenEmail,
    trackOnYesButton: trackSIWA_AccountLinkAttemptWithHiddenEmail,
    cancelToS: cancelToSAction,
    acceptSocialToS: acceptSocialToSAction,
    showToS: showToSAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialLookupPage),
);
